import { companyTypesEnum } from 'constants/companyTypes';

export const isPermissionWithCompanyType = () => {
  const type = localStorage.getItem('type');
  let isTypeSingle = type === companyTypesEnum.SINGLE;
  return {
    isTypeSingle,
  };
};
